import { AdvanceType } from "src/app/@core/constants";
import { PaymentsRequestModel } from "./PaymentRequestModel";

export class AdvanceCreateRequest {
    paymentsRequestModel: PaymentsRequestModel;
    replicateInExternalSystem: boolean;
    customerCode: string;
    observations: string;
    oldAdvanceCode: string;
    advanceType: AdvanceType;
    originalAdvanceCode: string;
    weddingCode: string;
    weddingName: string;
    guestName: string;
    productCode: string;
    guestEmail: string;
    guestPhone: string;
    origin: string;

    constructor() {
        this.paymentsRequestModel = new PaymentsRequestModel();
        this.replicateInExternalSystem = false;
        this.customerCode = "";
        this.observations = "";
        this.oldAdvanceCode = "";
        this.advanceType = AdvanceType.SHOP;
        this.originalAdvanceCode = "";
        this.weddingCode = "";
        this.weddingName = "";
        this.guestName = "";
        this.productCode = "";
        this.guestEmail = "";
        this.guestPhone = "";
        this.origin = "";
    }
}